<template>
  <!-- 付款信息 -->
  <el-card class="m-b" v-if="hasPayData">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">{{ title }}</span>
    </div>
    <div v-if="$route.query.type !== 'check' && system === 'purchaser'" class="pay-btn">
      <el-button type="primary" @click="addPayRecord('add', {})">新增付款申请</el-button>
    </div>
    <zl-server-page-table
      :border="false"
      showTotal
      height="400px"
      ref="multipleTable"
      :api="getApi"
      :columns="columns"
    >
      <!-- template里面写的话会放到columns之后去渲染 -->
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <!-- 当前登录系统属于采购人登录 -->
          <template v-if="system === 'purchaser'">
            <template v-if="scope.row.status === 1">
              <el-link type="primary" @click="publishPay(scope.row)" :disabled="isDisabled">
                付款
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link type="primary" @click="cheHui(scope.row)" :disabled="isDisabled">
                撤回
              </el-link>
            </template>
            <template v-if="scope.row.status === 2">
              <el-link type="primary" @click="selectDetail(scope.row)">
                查看
              </el-link>
            </template>
            <template v-if="scope.row.status === 1 || scope.row.status === 2">
              <el-divider direction="vertical"></el-divider>
              <el-link  type="primary" @click="selectPayCert(scope.row)">
                查看申请付款凭证
              </el-link>
            </template>
            <template v-if="scope.row.status === 0">
              <el-link  type="primary" @click="addPayRecord('edit', scope.row)" :disabled="isDisabled">
                编辑
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link  type="primary" @click="del(scope.row)" :disabled="isDisabled">
                删除
              </el-link>
            </template>
          </template>
          <!-- 当前登录系统属于供应商登录 -->
          <template v-else>
            <el-link type="primary" @click="selectDetail(scope.row)">
              查看
            </el-link>
          </template>
        </template>
      </el-table-column>
    </zl-server-page-table>
    <div class="order-total-box" v-if="$route.query.type === 'check'">
      <p>
        <span>已付款金额（元）：</span>
        <span>{{_util.formatMoney(realTotalMoney)}}</span>
      </p>
    </div>
  </el-card>
</template>
<script>
import store from '@/store'
import dayjs from 'dayjs'
import addPayRecordDialog from '../addPayRecordDialog.vue'
import payRecordSelectDialog from '@/components/dialog/payRecordSelectDialog.vue'
import publishPayRecord from '../publishPayRecord.vue'
import orderPayCertDialog from '../orderPayCertDialog.vue'
import { mapActions } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: '付款信息'
    },
    fromPage: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    accountId: {
      type: String,
      default: ''
    },
    currencyCH: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      system: 'purchaser', // 当前登录的是哪个系统
      columns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '付款单号',
          prop: 'orderPayCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '申请付款金额(元)',
          prop: 'applyMoney',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '实际付款金额(元)',
          prop: 'realMoney',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '提交时间',
          prop: 'createTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) =>
            row.createTime &&
            dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          label: '付款状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          render: (h, row) => (
            <span>
              <span style='color: #3973FF;'>
                { row.status === 2 ? '已付款' : (row.status === 1 ? '待付款' : '待提交') }
              </span>
            </span>
          )
        }
      ],
      hasPayData: true,
      applyMoney: '', // 新增付款申请填的申请金额
      paymentId: '', // 新增付款申请生成的付款记录id
      realTotalMoney: 0, // 已付款总金额
      defaultApplyMoney: '', // 默认申请付款金额
      yingFuMoney: 0 // 应付金额（元）
    }
  },
  computed: {
    // 订单id
    id() {
      return this.orderId || this.$route.query.id
    },
    isDisabled() {
      return this.$route.query.type === 'check'
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions([
      'pageOrderPaymentBJForDuiZhangJieSuan',
      'delOrderPayment',
      'cheHuiOrderPayment',
      'countApplyMoneyOrder',
      'getCountTotalMoney',
      'getCountTotalMoneyGys'
    ]),
    initData() {
      this.system = this.$store.state.system
      if (this.fromPage !== 'settlement') {
        this.getDefaultApplyMoney()
      }
      this.getTotalMoney()
    },
    getTotalMoney() {
      // 查询主订单已收货总金额，已付款总金额
      this[`${this.system === 'purchaser' ? 'getCountTotalMoney' : 'getCountTotalMoneyGys'}`]({
        // orderId: this.$route.query.id
        orderId: this.id
      }).then(res => {
        this.realTotalMoney = res.realTotalMoney
      })
    },
    getApi(args) {
      const params = {
        pageNum: args.page,
        pageSize: args.size
      }
      let apiName = this.system === 'purchaser' ? 'getPayListByOrderId' : 'listZSByOrderIdGys'
      if (this.fromPage === 'settlement') {
        apiName = 'pageOrderPaymentBJForDuiZhangJieSuan'
        params.accountId = this.accountId
      } else {
        params.orderId = this.id
      }
      return store.dispatch(apiName, params).then(res => {
        // 用于父组件子订单信息是否显示，么有就不显示
        // 只针对查看页面
        if (this.$route.query.type === 'check') {
          this.hasPayData = res.list && res.list.length
        }
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    // 查看详情
    selectDetail(row) {
      store.dispatch(`${this.system === 'purchaser' ? 'getPaymentInfoOrder' : 'getPaymentInfoOrderGys'}`, {
        paymentId: row.id
      }).then(res => {
        this.$zl.dialog.openFull(payRecordSelectDialog, {
          detailInfo: res,
          currencyCH: this.currencyCH
        }).then((res) => {
        })
      })
    },
    // 发布
    publishPay(row) {
      this.$zl.dialog.openFull(publishPayRecord, {
        // orderId: this.$route.query.id,
        orderId: this.id,
        id: row.id,
        orderPayCode: row.orderPayCode,
        applyMoney: row.applyMoney,
        applyRemark: row.applyRemark,
        currencyCH: this.currencyCH
      }).then((res) => {
        this.$refs.multipleTable.refresh()
        this.$emit('payRecordSuccess')
      })
    },
    // 撤回
    cheHui(row) {
      this.$confirm('确定撤回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('cheHuiOrderPayment', { id: row.id }).then(res => {
          if (res) {
            this.$message.success('撤回成功')
            this.$refs.multipleTable.refresh()
          }
        })
      }).catch(() => {
      })
    },
    // 删除
    del(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('delOrderPayment', { id: row.id }).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.$refs.multipleTable.refresh()
          }
        })
      }).catch(() => {
      })
    },
    // 查看付款凭证
    selectPayCert(row) {
      this.$zl.dialog.openFull(orderPayCertDialog, {
        // orderId: this.$route.query.id,
        orderId: this.id,
        applyMoney: row && row.applyMoney || this.applyMoney,
        paymentId: row && row.id || this.paymentId
      }).then((res) => {
      })
    },
    // 新增付款申请
    addPayRecord(type, row) {
      this.$zl.dialog.openFull(addPayRecordDialog, {
        fromPage: this.fromPage,
        accountId: this.accountId,
        // orderId: this.$route.query.id,
        type,
        id: row.id,
        yingFuMoney: this.yingFuMoney,
        orderId: this.id,
        defaultApplyMoney: type === 'edit' ? row.applyMoney : this.defaultApplyMoney,
        currencyCH: this.currencyCH
      }).then((res) => {
        if (res) {
          this.paymentId = res.id
          this.applyMoney = res.applyMoney
          if (res.type !== 'save') {
            this.selectPayCert()
          }
        }
        this.$refs.multipleTable.refresh()
      })
    },
    // 获取默认的申请付款金额
    async getDefaultApplyMoney() {
      await this.countApplyMoneyOrder({
        // orderId: this.$route.query.id
        orderId: this.id
      }).then(res => {
        // this.defaultApplyMoney = res.applyMoney
        this.yingFuMoney = res.applyMoney
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.pay-btn{
  margin-bottom: 20px;
}
</style>
